<template>
  <div
    role="radiogroup"
    data-test="radio-group"
    class="adn-radio-group"
    :class="{ 'adn-radio-group--horizontal': horizontal }"
  >
    <slot
      :on-selected-value="selectedValue"
      :group-name="name"
      :initial-value="initialValue"
      :disabled="disabled"
    ></slot>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AdnRadioGroup',
  props: {
    name: {
      type: String,
      required: true,
    },
    horizontal: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    initialValue: {
      type: [String, Number, Boolean],
      default: null,
    },
  },
  emits: ['selectedValue'],
  setup(_, { emit }) {
    /**
     * 'input' event. emits the value received from the AdnRadioButton selected
     *
     * @event input
     * @type {any}
     */
    function selectedValue(value) {
      emit('selectedValue', value)
    }
    return {
      selectedValue,
    }
  },
})
</script>

<style lang="scss" scoped>
.adn-radio-group {
  white-space: nowrap;
}

.adn-radio-group--horizontal {
  display: flex;

  .adn-radio-button {
    margin-right: 1rem;
  }
}
</style>
